import { useCallback } from 'react'
import classNames from 'classnames'
import {
  addSelectedImages,
  deleteUploadImage,
  removeSelectedImage,
  setSelectedImages,
} from 'features/image/imageLibrarySlice'
import { batch, useDispatch, useSelector } from 'react-redux'
import * as PropTypes from 'prop-types'
import NoneAnchor from 'components/NoneAnchor'

const ImageLibraryListItem = ({ image: item = [] }) => {
  const dispatch = useDispatch()
  const { tabIndex, maxCount, selectedImages } = useSelector(
    state => state.image.imageLibrary
  )

  const includes = useCallback(
    image => selectedImages.findIndex(({ id }) => id === image.id) !== -1,
    [selectedImages]
  )

  const handleToggle = image => {
    if (maxCount === 1) {
      dispatch(setSelectedImages(image))
    } else {
      if (includes(image)) {
        dispatch(removeSelectedImage(image))
      } else {
        if (selectedImages.length < maxCount) {
          dispatch(addSelectedImages(image))
        }
      }
    }
  }
  const handleDelete = (event, image) => {
    event.preventDefault()
    event.stopPropagation()
    batch(() => {
      dispatch(removeSelectedImage(image))
      dispatch(deleteUploadImage(image))
    })
  }

  const { url, name, width, height } = item
  return (
    <li
      className={classNames({
        on: includes(item) && maxCount === 1,
        on_order: includes(item) && maxCount > 1,
      })}>
      <NoneAnchor
        className="link_material"
        onClick={() => {
          handleToggle(item)
        }}>
        <span className="img_file">
          <span className="inner_img_file">
            <img
              src={url}
              style={{ maxWidth: 170, maxHeight: 118 }}
              alt={name}
            />
          </span>
          <span className="frame_g" />
          <span className="load_img">
            <span className="ico_comm ico_loading">로딩완료</span>
          </span>
          <span className="ico_comm ico_liston">
            {selectedImages.findIndex(selected => selected.url === url) + 1}
          </span>
        </span>
        {tabIndex === 0 && (
          <button
            type="button"
            className="btn_del"
            onClick={event => handleDelete(event, item)}>
            <span className="ico_comm ico_del">삭제</span>
          </button>
        )}
      </NoneAnchor>
      <p className="txt_file">{`${width}x${height}`}</p>
      <p className="txt_filename">{name}</p>
    </li>
  )
}
ImageLibraryListItem.propTypes = {
  image: PropTypes.shape({
    id: PropTypes.string,
    url: PropTypes.string,
    name: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
  }).isRequired,
}
export const ImageLibraryList = () => {
  const { tabIndex, pending, images, libraryImages } = useSelector(
    state => state.image.imageLibrary
  )
  const displayImages = tabIndex === 0 ? images : libraryImages
  if (tabIndex !== 0 && pending) {
    return null
  } else {
    return displayImages.map(image => (
      <ImageLibraryListItem key={image.id} image={image} />
    ))
  }
}
const ImageLibrayPendingListItem = ({ name, width, height }) => {
  let thumbWidth
  let thumbHeight
  const ratio = width / height
  if (ratio > 170 / 118) {
    thumbWidth = 170
    thumbHeight = 170 / ratio
  } else {
    thumbWidth = 118 / ratio
    thumbHeight = 118
  }
  return (
    <li key={name}>
      <NoneAnchor className="link_material">
        <span className="img_file">
          <span className="inner_img_file">
            <span
              className="bg_file"
              style={{ width: thumbWidth, height: thumbHeight }}
            />
          </span>
          <span className="frame_g" />
          <span className="load_img">
            <span className="ico_comm ico_loading">로딩완료</span>
          </span>
        </span>
      </NoneAnchor>
      <p className="txt_file">{`${width}x${height}`}</p>
      <p className="txt_filename">{name}</p>
    </li>
  )
}
ImageLibrayPendingListItem.propTypes = {
  name: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
}
export const ImageLibrayPendingList = () => {
  const { pendingImages } = useSelector(state => state.image.imageLibrary)
  return pendingImages.map(({ name, width, height }) => (
    <ImageLibrayPendingListItem
      key={name}
      name={name}
      width={width}
      height={height}
    />
  ))
}
